<div *ngIf="showHideLoader" class="overlay">
	<mat-progress-spinner class="spinner"
		mode="indeterminate">
	</mat-progress-spinner>
</div>